// extracted by mini-css-extract-plugin
export default {"noResults":"no-results_noResults__iC+q1","noResultsContent":"no-results_noResultsContent__zRYOa","header":"no-results_header__013t7","message":"no-results_message__agJ50"};